export function getContrast(hex, bw) {
    if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error("Invalid HEX color.");
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join("0");
    return (zeros + str).slice(-len);
}

/**
 *
 * @param {Object} setting
 * @param {Number | Function} setting.ratio Number || (windowSize: Number) => Number
 * @param {Number | Function} setting.max Number || (windowSize: Number) => Number
 * @param {Number | Function} setting.min Number || (windowSize: Number) => Number
 * @param {Number} windowSize
 * @returns
 */
const calcWindowSize = (setting, windowSize) => {
    let { ratio = 1, min = 0, max = Number.MAX_SAFE_INTEGER } = setting;
    if (typeof min === "function") {
        min = min(windowSize);
    }
    if (typeof max === "function") {
        max = max(windowSize);
    }
    if (typeof ratio === "function") {
        ratio = ratio(windowSize);
    }
    return Math.max(min, Math.min(max, ratio * windowSize));
};

/**
 *
 * @param {Object} settings
 * @param {Object} settings.width
 * @param {Object} settings.height
 * @returns
 */
export const getCalcWindowSize = settings => {
    const size = { width: 0, height: 0 };
    if (settings.width) {
        size.width = calcWindowSize(settings.width, window.innerWidth);
    }
    if (settings.height) {
        size.height = calcWindowSize(settings.height, window.innerHeight);
    }
    return size;
};

function detectMob() {
    const ua = navigator.userAgent;
    return (
        /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua) ||
        /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
    );
}

const isMobile = detectMob();
export const checkIsMobile = () => isMobile;

Math.radians = function (degrees) {
    return (degrees * Math.PI) / 180;
};

// Convert from radians to degrees.
Math.degrees = function (radians) {
    return (radians * 180) / Math.PI;
};
